/* React & React Native libraries */
import { Text, View, Image, ScrollView, Platform } from 'react-native'

/* Custom Components and Constants */
import TutorialContent from './_components/TutorialContent.js'

import { i18n } from '$localization/config.js'

/* Custom Stylesheets */
import global_styles from '$constants/styles/global.styles.js'

const RelationshipInfoTutorialPage2 = ({ colorSettings }) => (
  <View
    style={[
      global_styles.content,
      {
        backgroundColor: 'transparent',
        flex: 1.0,
      },
    ]}
  >
    <View style={{ paddingHorizontal: 16, paddingVertical: 16 }}>
      <Text
        style={[
          global_styles.headerBarMainTitle,
          {
            color: colorSettings?.text_input_title_color_2,
          },
        ]}
      >
        {i18n.t('twins')?.capitalize}
      </Text>
    </View>
    <ScrollView
      style={{ width: '100%' }}
      contentContainerStyle={{ paddingHorizontal: 20, paddingVertical: 24 }}
    >
      <View
        style={[
          global_styles.webContainer,
          {
            backgroundColor: '',
          },
        ]}
      >
        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-1.png')}
          descriptionText={i18n.t('tap_the_profile')?.default}
          demoImageSource={require('$assets/images/new_assets/t3-img1.png')}
        />

        <View style={{ height: 48 }} />

        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-2.png')}
          descriptionText={
            i18n.t('scroll_to_relationship_section_and_toggle_on_twins')
              ?.default
          }
          demoImageSource={require('$assets/images/new_assets/t3-img2.png')}
        />

        <View style={{ height: 48 }} />
        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-3.png')}
          descriptionText={
            i18n.t(
              'select_dquoteadd_twinsdquote_and_follow_the_prompts_to_select_the_other_twin(s)'
            )?.default
          }
          demoImageSource={require('$assets/images/new_assets/t3-img3.png')}
        />
      </View>
    </ScrollView>
  </View>
)

export default RelationshipInfoTutorialPage2
